import { compact } from "lodash";

/** removes milliseconds from datestamp, for shorter x-axis labels  */

function dateStampTrimmer() {
  return this.value.slice(0, -4);
}

let baseBatteryChart = (categories, data, isLPD) => {
  let yAxis;
  if (isLPD) {
    yAxis = {
      title: { text: "Battery Voltage" },
      min: 0,
      max: 4400,
    };
  } else {
    yAxis = {
      title: { text: "Battery Percentage" },
      min: 0,
      max: 120,
    };
  }

  return {
    chart: {
      zoomType: "x",
    },
    title: {
      text: "Battery Report",
    },
    xAxis: {
      type: "category",
      categories: categories,
      title: {
        text: "Reports (Oldest -> Newest)",
      },
      labels: {
        align: "right",
        rotation: -20,
        formatter: dateStampTrimmer,
      },
    },
    yAxis: yAxis,
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: "Unit Battery",
        type: "line",
        data: data,
      },
    ],
  };
};

let batteryChartOptions = (models, isLPD) => {
  let categories = models["categories"],
    series1 = models["series1"],
    series2 = models["series2"],
    errors = models["errors"];

  let chartConfig = baseBatteryChart(categories, series1, isLPD);

  if (compact(errors).length > 0)
    chartConfig.series.push({
      name: "Errors",
      color: "#FF0000",
      type: "spline",
      data: errors,
    });

  if (series2.length > 0)
    chartConfig.series.push({
      name: "2nd Unit Battery",
      color: "#FF00FF",
      type: "line",
      data: series2,
    });
  return chartConfig;
};

export default batteryChartOptions;
